import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface SearchHistoryItem {
    id: string;
    type: "procedure" | "specialty";
    label: string;
    slug: string;
    specialty?: string; // For procedures, the specialty name
    specialtySlug?: string; // For procedures, the specialty slug
}

interface SearchHistoryState {
    history: SearchHistoryItem[];
    addToHistory: (item: Omit<SearchHistoryItem, "id">) => void;
    removeFromHistory: (id: string) => void;
    clearHistory: () => void;
}

const MAX_HISTORY_ITEMS = 10;

export const useSearchHistoryStore = create<SearchHistoryState>()(
    persist(
        (set, get) => ({
            history: [],

            addToHistory: (item) => {
                const { history } = get();
                const newItem: SearchHistoryItem = {
                    ...item,
                    id: `${item.type}-${item.slug}`,
                };

                // Remove existing item if it exists
                const filteredHistory = history.filter(
                    (h) => h.id !== newItem.id,
                );

                // Add new item to the beginning
                const newHistory = [newItem, ...filteredHistory].slice(
                    0,
                    MAX_HISTORY_ITEMS,
                );

                set({ history: newHistory });
            },

            removeFromHistory: (id) => {
                const { history } = get();
                set({ history: history.filter((item) => item.id !== id) });
            },

            clearHistory: () => {
                set({ history: [] });
            },
        }),
        {
            name: "search-history",
        },
    ),
);
